import { Action, StepActions } from './step-actions';
import { tassign } from 'tassign';
import { StepState, initialStepState } from './step-state.model';

/**
* StepReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
**/
export const StepReducer = function (state: StepState = initialStepState, action: Action): StepState {
  switch (action.type) {
    case StepActions.SET_NEXT_STEP:
      return tassign(state, {
        nextStep: action.payload.step
      });
    case StepActions.SET_ERROR_STATE:
      return tassign(state, {
        error: action.payload.error
      });
    case StepActions.IS_MOBILE:
      return tassign(state, {
        isMobile: action.payload.isMobile
      });
    case StepActions.STORE_GUID:
      return tassign(state, {
        storeGuid: action.payload.storeGuid
      });
    case StepActions.STORE_GUID_VALUE:
      return tassign(state, {
        storeGuidValue: action.payload.storeGuidValue, 
        apiAction: action.payload.apiAction
      });
    case StepActions.STORE_VIN:
      return tassign(state, {
        storeVin: action.payload.storeVin
      });
    case StepActions.IS_VEHICLE_ASSOCIATED:
      return tassign(state, { vehicleAssociationDetails: action.payload.vehicleAssociationDetails });
    default:
      return state;
  }
};

